export default [
  {
    path: "/estoque",
    name: "estoque",
    label: "Estoque",
    component: () => import("@/components/home/MenuEstoque.vue"),
  },
  {
    path: "/estoque/cadastros",
    name: "estoque.cadastros",
    label: "Cadastros",
    component: () => import("@/components/estoque/cadastros/SubmenuEstoqueCadastros.vue"),
  },
  {
    path: "/estoque/configuracoes",
    name: "estoque.configuracoes",
    label: "Configurações do Estoque",
    component: () => import("@/components/estoque/configuracoes/ConfiguracoesEstoque.vue"),
  },
  {
    path: "/estoque/cadastros/produtos",
    name: "estoque.cadastros.produtos",
    label: "Produtos",
    component: () => import("@/components/estoque/cadastros/produto/SubmenuEstoqueCadastrosProdutos.vue"),
  },
  {
    path: "/estoque/cadastros/produtos/gerenciar",
    name: "estoque.cadastros.produtos.gerenciar",
    label: "Gerenciar Produtos",
    component: () => import("@/components/estoque/cadastros/produto/produtos.vue"),
  },
  {
    path: "/estoque/cadastros/depositos",
    name: "estoque.cadastros.depositos",
    label: "Visualizar Lista de Depósitos",
    component: () => import("@/components/estoque/cadastros/depositos/gerenciar-depositos.vue"),
  },
  {
    path: "/estoque/cadastros/lotes",
    name: "estoque.cadastros.lotes",
    label: "Visualizar Lista de Lotes",
    component: () => import("@/components/estoque/cadastros/lotes/gerenciar-lotes.vue"),
  },
  {
    path: "/estoque/cadastros/lotes/novo",
    name: "estoque.cadastros.lotes.novo",
    label: "Novo Lote",
    component: () => import("@/components/estoque/cadastros/lotes/novo-lote.vue"),
  },
  {
    path: "/estoque/cadastros/depositos/nao-enderecado",
    name: "estoque.cadastros.depositos.nao-enderecado",
    label: "Estoque Não Endereçado",
    component: () => import("@/components/estoque/cadastros/depositos/estoque-nao-enderecado.vue"),
  },
  {
    path: "/estoque/cadastros/depositos/novo",
    name: "estoque.cadastros.depositos.novo",
    label: "Cadastrar Depósitos",
    component: () => import("@/components/estoque/cadastros/depositos/novo-deposito.vue"),
  },
  {
    path: "/estoque/cadastros/depositos/editar/:id",
    name: "estoque.cadastros.depositos.editar",
    label: "Editar Depósitos",
    component: () => import("@/components/estoque/cadastros/depositos/editar-deposito.vue"),
  },
  {
    path: "/estoque/cadastros/depositos/visualizar/:id",
    name: "estoque.cadastros.depositos.visualizar",
    label: "Visualizar Depósito",
    component: () => import("@/components/estoque/cadastros/depositos/visualizar-deposito.vue"),
  },
  {
    path: "/estoque/cadastros/depositos/transferir-produto/:id",
    name: "estoque.cadastros.depositos.transferir",
    label: "Transferir Para Depósito",
    component: () => import("@/components/estoque/cadastros/depositos/transferir-para-depositos.vue"),
  },
  {
    path: "/estoque/cadastros/depositos/registro",
    name: "estoque.cadastros.depositos.registro",
    label: "Visualizar Registros de Movimentações",
    component: () => import("@/components/estoque/cadastros/depositos/registro-movimentacao.vue"),
  },
  {
    path: "/estoque/cadastros/produtos/cadastro",
    name: "estoque.cadastros.produtos.novo",
    label: "Cadastrar Produtos",
    component: () => import("@/components/estoque/cadastros/produto/editor-produto-geral.vue"),
  },
  {
    path: "/estoque/cadastros/produtos/historico/:codpro",
    name: "estoque.cadastros.produtos.historico",
    label: "Visualizar Histórico de Produtos Específicos",
    component: () => import("@/components/estoque/cadastros/produto/historico-estoque.vue"),
  },
  {
    path: "/estoque/cadastros/produtos/custos-por-preco",
    name: "estoque.cadastros.produtos.rentabilidade",
    label: "Visualizar Custos por Preço de um Produto",
    component: () => import("@/components/estoque/cadastros/produto/rentabilidade-produto.vue"),
  },
  {
    path: "/estoque/cadastros/produtos/editar/:id",
    name: "estoque.cadastros.produtos.editar",
    label: "Editar Produtos",
    component: () => import("@/components/estoque/cadastros/produto/editor-produto-geral.vue"),
  },
  {
    path: "/estoque/cadastros/produtos/visualizar/:id",
    name: "estoque.cadastros.produtos.visualizar",
    label: "Visualizar Produtos",
    component: () => import("@/components/estoque/cadastros/produto/VisualizarProduto.vue"),
  },
  {
    path: "/estoque/cadastros/produtos/unidades-medida",
    name: "estoque.cadastros.produtos.unidade-medida",
    label: "Visualizar Lista de Unidades de Medida",
    component: () => import("@/components/estoque/cadastros/unidade-medida/unidade-medida.vue"),
  },
  {
    path: "/estoque/cadastros/produtos/unidade-medida/novo",
    name: "estoque.cadastros.produtos.unidade-medida.novo",
    label: "Visualizar Lista de Unidades de Medida",
    component: () => import("@/components/estoque/cadastros/unidade-medida/cadastro-unidade-medida.vue"),
  },
  {
    path: "/estoque/cadastros/produtos/unidade-medida/editar/:id",
    name: "estoque.cadastros.produtos.unidade-medida.editar",
    label: "Visualizar Lista de Unidades de Medida",
    component: () => import("@/components/estoque/cadastros/unidade-medida/cadastro-unidade-medida.vue"),
  },
  {
    path: "/estoque/cadastros/produtos/linhas",
    name: "estoque.cadastros.produtos.linhas",
    label: "Visualizar Lista de Linhas",
    component: () => import("@/components/estoque/cadastros/linhas/linhas.vue"),
  },
  {
    path: "/estoque/cadastros/produtos/grupos-produtos",
    name: "estoque.cadastros.produtos.grupos-produtos",
    label: "Visualizar Lista de Grupos de Produtos",
    component: () => import("@/components/estoque/cadastros/grupo-produto/grupos-produtos.vue"),
  },
  {
    path: "/estoque/cadastros/produtos/volumes",
    name: "estoque.cadastros.produtos.volumes",
    label: "Visualizar Lista de Volumes",
    component: () => import("@/components/estoque/cadastros/volume/volumes.vue"),
  },
  {
    path: "/estoque/inventarios",
    name: "estoque.inventarios",
    label: "Inventário",
    component: () => import("@/components/estoque/inventario/home-inventario.vue"),
  },
  {
    path: "/estoque/inventarios/produtos",
    name: "estoque.inventarios.produtos",
    label: "Visualizar Lista de Inventário de Produtos",
    component: () => import("@/components/estoque/inventario/inventarios-produtos.vue"),
  },
  {
    path: "/estoque/inventarios/produtos/editar/:id",
    name: "estoque.inventarios.produtos.editar",
    label: "Editar Produtos",
    component: () => import("@/components/estoque/inventario/produtos-edit.vue"),
  },
  {
    path: "/estoque/inventarios/produtos-restantes",
    name: "estoque.inventarios.produtos.restantes",
    label: "Visualizar Lista de Produtos Restantes",
    component: () => import("@/components/estoque/inventario/inventarios-produtos-restantes.vue"),
  },
  {
    path: "/estoque/inventarios/depositos",
    name: "estoque.inventarios.depositos",
    label: "Visualizar Inventário de Depósitos",
    component: () => import("@/components/estoque/inventario/inventarios-depositos.vue"),
  },
  {
    path: "/estoque/inventarios/depositos/:id",
    name: "estoque.inventarios.depositos.editar",
    label: "Editar Inventário de Depósitos",
    component: () => import("@/components/estoque/inventario/inventario-deposito.vue"),
  },
  {
    path: "/estoque/inventarios/materia-prima",
    name: "estoque.inventarios.insumos",
    label: "Visualizar Lista de Inventário de Insumos",
    component: () => import("@/components/estoque/inventario/inventarios-insumos.vue"),
  },
  {
    path: "/estoque/inventarios/materia-prima/editar/:id",
    name: "estoque.inventarios.insumos.editar",
    label: "Editar Insumos",
    component: () => import("@/components/estoque/inventario/insumos-edit.vue"),
  },
  {
    path: "/estoque/relatorios",
    name: "estoque.relatorios",
    label: "Relatórios",
    component: () => import("@/components/estoque/relatorios/home-relatorios.vue"),
  },
  {
    path: "/estoque/relatorios/custos-totais",
    name: "estoque.relatorios.custo",
    label: "Relatório de Custos Totais",
    component: () => import("@/components/estoque/relatorios/produtos-custo.vue"),
  },
  {
    path: "/estoque/relatorios/custos-com-indiretos-totais",
    name: "estoque.relatorios.custo-com-indiretos",
    label: "Relatório de Custos Totais com Indiretos",
    component: () => import("@/components/estoque/relatorios/produtos-custo-com-indiretos.vue"),
  },
  {
    path: "/estoque/relatorios/produtos-venda",
    name: "estoque.relatorios.produtos-venda",
    label: "Relatório de Produtos para Venda",
    component: () => import("@/components/estoque/relatorios/relatorio-produtos-venda.vue"),
  },
  {
    path: "/estoque/inventarios/materia-prima-restantes",
    name: "estoque.inventarios.insumos.restantes",
    label: "Visualizar Lista de Insumos Restantes",
    component: () => import("@/components/estoque/inventario/inventarios-insumos-restantes.vue"),
  },
  {
    path: "/estoque/historico",
    name: "estoque.historico",
    label: "Histórico de Produtos",
    component: () => import("@/components/estoque/historico/historico-produtos.vue"),
  },
  {
    path: "/estoque/relatorios/produtos-vendidos",
    name: "estoque.relatorios.produtos-vendidos",
    label: "Relatório de Produtos Vendidos",
    component: () => import("@/components/estoque/relatorios/produtos-vendidos.vue"),
  },
  {
    path: "/estoque/relatorios/produtos-com-estoque-baixo",
    name: "estoque.relatorios.produtos-com-estoque-baixo",
    label: "Relatório de Produtos com Estoque Baixo",
    component: () => import("@/components/estoque/relatorios/produtos-com-estoque-baixo.vue"),
  },
  {
    path: "/estoque/relatorios/historico-de-estoque",
    name: "estoque.relatorios.historico-de-estoque",
    label: "Histórico de Estoque",
    component: () => import("@/components/estoque/relatorios/HistoricoDeEstoque.vue"),
  },
  {
    path: "/estoque/cadastros/insumos/gerenciar",
    name: "estoque.cadastros.insumos.gerenciar",
    label: "Visualizar Lista de Insumos",
    component: () => import("@/components/pcp/cadastros/materia-prima/materia-prima.vue"),
  },
  {
    path: "/estoque/cadastros/insumos",
    name: "estoque.cadastros.insumos",
    label: "Insumos",
    component: () => import("@/components/estoque/cadastros/insumos/SubmenuEstoqueCadastrosInsumos.vue"),
  },
  {
    path: "/estoque/cadastros/insumos/grupos",
    name: "estoque.cadastros.insumos.grupos",
    label: "Visualizar Lista de Grupos de Insumos",
    component: () => import("@/components/pcp/cadastros/grupo-produto/grupos-materia-prima.vue"),
  },
  {
    path: "/estoque/cadastros/insumos/unidade-medida",
    name: "estoque.cadastros.insumos.unidade-medida",
    label: "Visualizar Lista de Unidades de Medida",
    component: () => import("@/components/pcp/cadastros/unidade-medida/unidade-medida.vue"),
  },
  {
    path: "/estoque/cadastros/insumos/unidade-medida/novo",
    name: "estoque.cadastros.insumos.unidade-medida.novo",
    label: "Cadastrar Unidades de Medida",
    component: () => import("@/components/pcp/cadastros/unidade-medida/cadastro-unidade-medida.vue"),
  },
  {
    path: "/estoque/cadastros/insumos/editar/:id",
    name: "estoque.cadastros.insumos.editar",
    label: "Editar Insumos",
    component: () => import("@/components/pcp/cadastros/materia-prima/form-materia-prima.vue"),
  },
  {
    path: "/estoque/cadastros/insumos/visualizar/:id",
    name: "estoque.cadastros.insumos.visualizar",
    label: "Visualizar Insumos",
    component: () => import("@/components/pcp/cadastros/materia-prima/VisualizarInsumo.vue"),
  },
  {
    path: "/estoque/cadastros/insumos/cadastrar",
    name: "estoque.cadastros.insumos.novo",
    label: "Cadastrar Insumos",
    component: () => import("@/components/pcp/cadastros/materia-prima/form-materia-prima.vue"),
  },
  {
    component: () => import("@/components/contabilidade/imobilizados/imobilizados-home.vue"),
    name: "estoque.cadastros.imobilizados",
    path: "/estoque/cadastros/imobilizados",
    label: "Imobilizados",
  },
  {
    component: () => import("@/components/contabilidade/imobilizados/gerenciar-imobilizados.vue"),
    name: "estoque.cadastros.imobilizados.gerenciar",
    path: "/estoque/cadastros/imobilizados/gerenciar",
    label: "Gerenciar Imobilizados",
  },
  {
    component: () => import("@/components/contabilidade/imobilizados/grupos/gerenciar-grupos-imobilizado.vue"),
    name: "estoque.cadastros.imobilizados.grupos",
    path: "/estoque/cadastros/imobilizados/grupos",
    label: "Grupos de Imobilizados",
  },
  {
    component: () => import("@/components/contabilidade/imobilizados/form-imobilizado.vue"),
    name: "estoque.cadastros.imobilizados.novo",
    path: "/estoque/cadastros/imobilizados/novo",
    label: "Novo Imobilizado",
  },
  {
    component: () => import("@/components/contabilidade/imobilizados/form-imobilizado.vue"),
    name: "estoque.cadastros.imobilizados.editar",
    path: "/estoque/cadastros/imobilizados/editar/:id",
    label: "Editar Imobilizado",
  },
];
